import React from 'react';
import { Dismiss20Regular } from '@fluentui/react-icons';
import modalStyles from './css/SwitchToPasswordModal.module.css';

const SwitchToPasswordModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onClose();
        onConfirm();
    };

    return (
        <div className={modalStyles.overlay} role="presentation" onClick={onClose}>
            <div
                className={modalStyles.modal}
                role="dialog"
                aria-modal="true"
                aria-labelledby="switch-to-password-title"
                onClick={e => e.stopPropagation()}>
                <div className={modalStyles.header}>
                    <h2 id="switch-to-password-title" className={modalStyles.title}>
                        Switch to password sign-in?
                    </h2>
                    <button type="button" className={modalStyles.closeButton} onClick={onClose} aria-label="Close">
                        <Dismiss20Regular />
                    </button>
                </div>
                <div className={modalStyles.body}>
                    <p className={modalStyles.description}>
                        Microsoft Single Sign-On is currently your active sign-in method. Switching will disconnect Microsoft SSO, and
                        you&apos;ll create a Lens password to sign in. You&apos;ll then be signed in again to complete two-factor
                        authentication setup.
                    </p>
                    <div className={modalStyles.actions}>
                        <button type="button" className={modalStyles.primaryButton} onClick={handleConfirm}>
                            Switch to Password
                        </button>
                        <button type="button" className={modalStyles.cancelButton} onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SwitchToPasswordModal;
